import { isEmpty } from '@pes-ui/components/dist/collection/globals/utils';
import { useEffect, useState } from 'react';

import { switchProductSelector } from '@pes-ui/components/dist/collection/components/UI/product-selector/product-selector-utils.js';
import { TSwitchProductSelectorReturn } from '@pes-ui/components/dist/types/components/UI/product-selector/types';
import { TProductSelectorConfig } from '@pes-ui/components/dist/collection/components/UI/product-selector/product-selector';

export interface ISelector<T> {
    init: (config: T) => Promise<ISelector<T>>;
    open: (config: T, isWindowFeaturesDisable?: boolean) => ISelector<T>;
}

type TProductSelectorProps = {
    config: TProductSelectorConfig;
    renderFunction: (selector: ISelector<TProductSelectorConfig>) => JSX.Element;
}

export const ProductSelector = ({ config, renderFunction }: TProductSelectorProps) => {

    const [selector, setSelector] = useState<ISelector<TProductSelectorConfig>>(null);


    useEffect(() => {
        if (config) {
            const productSelector = switchProductSelector(config);
            if (productSelector) {
                productSelector.then((selector: Awaited<TSwitchProductSelectorReturn>) => {
                    setSelector(selector as ISelector<TProductSelectorConfig>);
                });
            }
        }
    }, []);

    if (isEmpty(config)) {
        return null;
    }

    return renderFunction(selector);

}
